import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { REMOVE_DISCOUNTS } from 'src/defaultImages.js';
import { FcDiscountService } from '../../services/fc-discount.service';
import { LocalStorageService } from '../../services/localStorage.service';

@Component({
  selector: 'app-delete-discount',
  templateUrl: './delete-discount.component.html',
  styleUrls: ['./delete-discount.component.css'],
})
export class DeleteDiscountComponent implements OnInit {
  images = {
    REMOVE_DISCOUNT: REMOVE_DISCOUNTS,
  };

  constructor(
    public _dialogRef: MatDialogRef<any>,
    public _dialog: MatDialog,
    public _localStorage: LocalStorageService,
    public _fcDiscount: FcDiscountService
  ) {}

  ngOnInit() {}
  cancelClicked() {
    this._dialogRef.close({ status: 0, data: null, message: 'closed' });
  }
  removeClicked() {
    let payload = {
      foodcourt: this._localStorage.get('restaurant_nameid'),
      token: this._localStorage.get('fc_cart_token'),
    };
    this._fcDiscount.removeDiscount(1,payload).then((response) => {
      if (response) {
        this._dialogRef.close({ status: 1, data: null, message: 'removed' });
      }
    });
  }
}
